/*@flow*/
import React from "react";
import type { LocalsT } from "lib/proforma/types";
import select from "lib/proforma/templates/Select";
import { AssociatedRecord } from "comps/ResourcePickers/AssociatedRecords/AssociatedRecord";
import { type Option } from "comps/ResourcePickers/AssociatedRecords/Resources";

const Contacts: any = select.clone({
  Select: (locals: LocalsT) => {
    const { onChange, attrs, value } = locals;
    const { selectProps } = attrs;

    return (
      <AssociatedRecord
        id={value}
        selectProps={selectProps || {}}
        onChange={(v: ?(Option | Option[])) => {
          if (Array.isArray(v)) {
            const result = v ? v.map((v2) => v2.value) : [];
            onChange(result);
          } else {
            // onChange(v ? v.value : null);
          }
        }}
      />
    );
  },
});

export default Contacts;
